module.exports = __webpack_public_path__ + "img/icon-s-truck.ff2b2a1c.png";